angular.module('psModule').factory('contactService',
    function ($resource) {
        return $resource('/ps/api/contact/:section', {}, {
            'getCountryCodes': {method: 'GET', params: {section: 'countryCode'}, isArray: true},
        });
    }
);
